import { Form } from "./Form";
import { axios } from "./axios";

export class GetAddress extends Form {

    constructor(get_address_key) {
        super({});

        this.uri = '/api/lookup-address';

        this.searching = false;
        this.results = false;
    }

    find(postcode, house = null) {
        let self = this;

        self.searching = true;

        return new Promise(resolve => {
            let endpoint = self.uri + '/find/' + postcode;

            if (house) {
                endpoint = endpoint + '/' + house;
            }

            axios.get(endpoint)
                .then(response => {

                    self.results = response.data;
                    self.resetSearch();

                    resolve(response);
                })
                .catch(error => {
                    if (error.response.data.Message) {
                        error.response.data.message = error.response.data.Message;
                    }

                    if (!postcode) {
                        error.response.data.errors = {
                            postcode: ['The postcode field is required.']
                        }
                    }

                    self.resetSearch();
                    self.setError(error);
                })
        });
    }

    selectAddress(index, postcode) {
        let self = this;

        return new Promise(resolve => {
            let selected_address = self.results.addresses[index];

            let address_2 = selected_address[1] + ' ' + selected_address[2]

            resolve({
                address_street: selected_address[0],
                address_2: address_2.trim(),
                town_city: selected_address[3],
                county: selected_address[4],
                country: 'United Kingdom',
                postcode: postcode
            });
        });
    }

    resetSearch() {
        this.resetErrors();
        this.searching = false
    }

}
